import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import '@simplybusiness/mobius-simplybusiness/dist/global.css';
import './index.css';

const app = React.createElement(App);

ReactDOM.render(app, document.getElementById('root'));
